export { default } from './TextOnly';



// WEBPACK FOOTER //
// ./src/components/templates/TextOnly/index.js